export default __webpack_public_path__ + "static/media/036-letter.03b89371.png";